import {
  Box,
  Typography,
  Avatar,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationBell from "Components/Notification/NotificationBell";
import ImgPath from "Constants/Imgs";
import ColorData from "Components/CstmTheme/ColorData";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../Redux/User/Action";
import { UserInitialStateType } from "DataTypes/Redux";
import SubTopBar, { menuItems } from "./SubTopBar";
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from "react";
import MobileDrawer from "Components/commonComponents/HederDrawer";
import SidebarDrawer from "Components/commonComponents/sidebarDrawer";
import { handleNavigation } from "Components/Header";
import { navItems } from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { disconnectChatHub } from "../../Service/signalRService";
import { toast } from "react-toastify";

const Topbar = ({ onMenuClick }: { onMenuClick?: () => void }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { myInfo }: UserInitialStateType = useSelector((state: any) => state?.user);

  const [expandedItems, setExpandedItems] = useState<{ [key: string]: boolean }>({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sidebarDrawerOpen, setSidebarDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = async () => {
    await disconnectChatHub();
    localStorage.clear();
    dispatch(clearUser() as any);
    window.location.href = "/home.html";
  };
  const currentDateTime = dayjs().format('D MMM, YYYY / h:mmA');
  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
    // Reset expanded items when drawer closes for better UX
    setExpandedItems({});
  }, []);
  const handleExpandClick = (id: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };


  return (
    <Box
      sx={{
        bgcolor: "white",
        boxShadow: 2,
        position: "sticky",
        top: 0,
        zIndex: 1000,
        minHeight: myInfo?.userType === "USER" ? "140px" : "80px", // Dynamic height based on user type
      }}
      className="topbar-box"
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 1, sm: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          minHeight: "80px", // Fixed height for main header content
        }}
      >
        {/* Left Section - Logo + Welcome */}
        <Box display="flex" alignItems="center" gap={2}>
          {isMobile && (
            <IconButton onClick={() => setSidebarDrawerOpen(true)} sx={{ color: ColorData.text.primary }}>
              <MenuIcon />
            </IconButton>
          )}
          <Avatar src={myInfo?.profileImageUrl || "/assets/images/dashboard-icons/profile-img.png"} />
          <Typography>
            Welcome,{" "}
            <strong style={{ color: ColorData.heading.main }}>
              {myInfo?.firstname || "Admin"}
            </strong>
          </Typography>
        </Box>

        {/* Right Section */}
        <Box display="flex" alignItems="center" gap={1}>

          {/* NOTIFICATION BELL */}
          <NotificationBell />

          {!isMobile && (
            <Box display="flex" alignItems="center" gap={2}>
              <Typography fontWeight={500} fontSize={"15px"}>
                {currentDateTime}
              </Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <IconButton
                  sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                  onClick={handleLogout}
                >
                  <ImgPath.LogoutIcon />
                  <Typography sx={{ ml: 1 }}>Logout</Typography>
                </IconButton>
              </Box>
            </Box>
          )}

          {isMobile && (
            <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: ColorData.text.primary }}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      {myInfo?.userType === "USER" && (
        <Box sx={{ borderTop: "1px solid #e0e0e0", bgcolor: "white" }}>
          <SubTopBar />
        </Box>
      )}

      <MobileDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        navItems={menuItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={(item: string) => {
          handleNavigation(item);
          handleDrawerClose();
        }}
      />

      <SidebarDrawer
        open={sidebarDrawerOpen}
        onClose={() => setSidebarDrawerOpen(false)}
        navItems={navItems}
        handleLogout={handleLogout}
      />
    </Box>
  );
};

export default Topbar;
